import React from "react";
import { JitsiMeeting } from "@jitsi/react-sdk";
import { Spinner } from "reactstrap";
const wrapperStyle = (w) => {
  return {
    position: "relative",
    width: w,
    background: "rgb(71, 71, 71)",
    height: "100%",
  };
};

const loader = () => (
  <div className="centered-text">
    <Spinner style={{ color: "#eee", height: 80, width: 80 }} />
  </div>
);

export class JitsiWrapper extends React.Component {
  state = {
    displayName: "",
    roomName: "",
    password: "",
    onCall: false,
    meetingEnded: false,
    videoOn: true,
    audioOn: true,
  };
  componentDidMount() {
    const { displayName, roomName } = this.props;
    this.setState({ displayName, roomName, onCall: true, meetingEnded: false });
  }

  setOnCallEndListener = (JitsiMeetAPI) => {
    const { onHangup = () => null } = this.props;
    JitsiMeetAPI.addListener("videoConferenceLeft", () => { onHangup(); })
    window.addEventListener("beforeunload", () => {
      JitsiMeetAPI.executeCommand("hangup");
      this.setState({ meetingEnded: true });
    });
  };
  render() {
    const {
      onCall,
      meetingEnded,
      videoOn,
      audioOn,
      roomName,
      displayName,
      password,
    } = this.state;
    const { height } = this.props;
    return onCall && !meetingEnded ? (
      <div style={wrapperStyle("100%")}>
        <JitsiMeeting
          // containerStyle={{ width: "100%", height }}
          roomName={roomName}
          userInfo={{
            displayName
          }}
          password={password}
          interfaceConfigOverwrite={{
            APP_NAME: "Jirango",
            DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
            DISABLE_PRESENCE_STATUS: true,
            DISPLAY_WELCOME_FOOTER: false,
            ENABLE_DIAL_OUT: false,
            HIDE_INVITE_MORE_HEADER: true,
            LANG_DETECTION: true,
            MOBILE_APP_PROMO: false,
            RECENT_LIST_ENABLED: false,
            SHOW_BRAND_WATERMARK: false,
            SHOW_CHROME_EXTENSION_BANNER: false,
            SHOW_JITSI_WATERMARK: false,
            SHOW_POWERED_BY: false,
            SHOW_PROMOTIONAL_CLOSE_PAGE: false,
          }}


          loadingComponent={loader}
          configOverwrite={{
            disableModeratorIndicator: true,
            disableReactions: true,
            disableReactionsModeration: true,
            disablePolls: true,
            startWithAudioMuted: false,
            hideEmailInSettings: true,
            enableCalendarIntegration: false,

            hideConferenceSubject: true,
            hideRecordingLabel: true,
            prejoinConfig: {
              enabled: false,
            },
            gravatar: {
              disabled: true,
            },
            welcomePage: {
              disabled: true,
            },
            securityUi: {
              hideLobbyButton: true,
              disableLobbyPassword: true
            },
            participantsPane: {
              // Hides the moderator settings tab.
              hideModeratorSettingsTab: true,
              // Hides the more actions button.
              hideMoreActionsButton: false,
              // Hides the mute all button.
              hideMuteAllButton: true,
            },
            breakoutRooms: {
              hideAddRoomButton: true,
              hideAutoAssignButton: true,
              hideJoinRoomButton: true
            },
            whiteboard:{
              enabled:false,
            },
            localRecording: {
              disable: true,
              notifyAllParticipants: true
            },
            filmstrip: {
              disableResizable: true,
              disableStageFilmstrip: true,
            },
            toolbarButtons: [
              'camera',
              // 'chat',
              // 'closedcaptions',
              'desktop',
              // 'dock-iframe',
              // 'download',
              // 'embedmeeting',
              // 'etherpad',
              // 'feedback',
              'filmstrip',
              // 'fullscreen',
              'hangup',
              'help',
              // 'highlight',
              // 'invite',
              // 'linktosalesforce',
              // 'livestreaming',
              'microphone',
              // 'noisesuppression',
              // 'participants-pane',
              // 'profile',
              // 'raisehand',
              // 'recording',
              // 'security',
              'select-background',
              'settings',
              // 'shareaudio',
              // 'sharedvideo',
              // 'shortcuts',
              'stats',
              'tileview',
              // 'toggle-camera',
              // 'undock-iframe',
              'videoquality',
            ],
          }}
          domain={"jitsi.riot.im"}
          onApiReady={(JitsiMeetAPI) => this.setOnCallEndListener(JitsiMeetAPI)}
          getIFrameRef = { (iframeRef) => { iframeRef.style.height = '100%'; } }
        />
      </div>
    ) : null;
  }
}